import list from 'src/modules/searchHistory/list/searchHistoryListReducers';
import form from 'src/modules/searchHistory/form/searchHistoryFormReducers';
import view from 'src/modules/searchHistory/view/searchHistoryViewReducers';
import destroy from 'src/modules/searchHistory/destroy/searchHistoryDestroyReducers';
import importerReducer from 'src/modules/searchHistory/importer/searchHistoryImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
